import { noVerifyGetMobileVerifyCode } from '@/api/login';
import { isTest } from '@/config';
import { message, notification } from 'ant-design-vue';
import { ref } from 'vue';

export function verifyCode() {
  const time = ref(0);
  // eslint-disable-next-line no-undef
  let timeId: NodeJS.Timeout;

  const codeLoading = ref(false);

  const onVerifyCode = async (mobile: string, codePass: boolean) => {
    if (!mobile) {
      message.error('请输入手机号码');
      return;
    }
    if (!codePass) {
      message.error('请输入正确的校验码');
      return;
    }
    if (codeLoading.value) {
      return;
    }

    codeLoading.value = true;
    try {
      const data = await noVerifyGetMobileVerifyCode({
        mobile,
      });

      if (data.status === 200) {
        message.success('发送成功');
        time.value = 60;
        console.log(isTest);
        if (isTest && data?.data?.verifyCode) {
          notification.success({
            message: '短信验证码：' + data?.data?.verifyCode,
            description: '',
            duration: 30,
          });
        }
        createTime();
      }

      codeLoading.value = false;
    } catch (error) {
      codeLoading.value = false;
    }
  };

  const createTime = () => {
    timeId = setTimeout(() => {
      time.value = time.value - 1;
      if (time.value > 0) {
        createTime();
      }
    }, 1000);
  };

  function cancel() {
    if (timeId) {
      clearTimeout(timeId);
      timeId = null;
    }
  }

  return {
    timeId,
    time,
    codeLoading,
    onVerifyCode,
    createTime,
    cancel,
  };
}
